import { combineReducers } from 'redux';
import { createReduceObject as createReqStatusReduceObject } from '../../../../common/reducers/_requestStatus/reducer';
import { createReduceObject as createListReduceObject } from '../../../../common/reducers/_list/reducer';
import createSaga from './saga';
import { reducerRegistry } from '../../../../reducerRegistry';

// eslint-disable-next-line import/prefer-default-export
export function registryCombineReducer(reducerName) {
  const combine = combineReducers({
    ...createReqStatusReduceObject(reducerName),
    ...createListReduceObject(reducerName)
  });
  reducerRegistry.register(reducerName, combine, createSaga);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccounts/combineRegistry.js